import React, { useEffect } from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { usePermissions } from 'components/providers/PermissionProvider'
import {
  reservationsPermission,
  reservationsMyReservationsPermission,
  reservationsReservationsPermission,
  reservationsReservationOffersPermission,
} from 'utils'
import { ROUTE } from 'constants/Routes'
import MyReservations from 'components/views/my-reservations/MyReservations'
import Reservations from 'components/views/reservations/Reservations'
import ReservationOffers from 'components/views/reservation-offers/ReservationOffers'

export default withRouter(({ history }) => {
  const permissions = usePermissions()

  const hasMyReservationsPermission = reservationsMyReservationsPermission(permissions),
    hasReservationsPermission = reservationsReservationsPermission(permissions),
    hasReservationOffersPermission = reservationsReservationOffersPermission(permissions)

  useEffect(() => {
    if (permissions.length) {
      if (!reservationsPermission(permissions)) {
        history.push(ROUTE.SUBSCRIPTIONS.HOME)
      }
    }
  }, [permissions])

  const NAV = [
    hasReservationsPermission && {
      uri: ROUTE.RESERVATIONS.RESERVATIONS,
    },
    hasMyReservationsPermission && {
      uri: ROUTE.RESERVATIONS.MY_RESERVATIONS,
    },
    hasReservationOffersPermission && {
      uri: ROUTE.RESERVATIONS.RESERVATION_OFFERS,
    },
  ].filter(el => el)

  if (history.location.pathname == ROUTE.RESERVATIONS.MAIN && NAV.length && NAV[0]) {
    return <Redirect to={NAV[0].uri} />
  }

  return (
    <Switch>
      {hasMyReservationsPermission && (
        <Route path={ROUTE.RESERVATIONS.MY_RESERVATIONS}>
          <MyReservations />
        </Route>
      )}
      {hasReservationsPermission && (
        <Route path={ROUTE.RESERVATIONS.RESERVATIONS}>
          <Reservations />
        </Route>
      )}
      {hasReservationOffersPermission && (
        <Route path={ROUTE.RESERVATIONS.RESERVATION_OFFERS}>
          <ReservationOffers />
        </Route>
      )}
    </Switch>
  )
})
